export default "__VITE_ASSET__NIbv4MEC__"